<!-- Modal Wizard Otimizado -->
<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="'⚡ Gerador Otimizado de Telas'"
  [nzWidth]="900"
  [nzFooter]="null"
  [nzClosable]="true"
  (nzOnCancel)="close()"
  nzCentered
  nzClassName="optimized-generator-modal">
  
  <ng-container *nzModalContent>
  <!-- Steps -->
  <nz-steps [nzCurrent]="currentStep" class="wizard-steps">
    <nz-step 
      *ngFor="let step of steps; let i = index"
      [nzTitle]="step.title"
      [nzDescription]="step.description"
      [nzIcon]="step.icon">
    </nz-step>
  </nz-steps>

  <div class="modal-content">
    
    <!-- ===== STEP 0: JSON Input ===== -->
    <div *ngIf="currentStep === 0" class="step-container step-json-input">
      <h3>
        <nz-icon nzType="file-text" nzTheme="outline"></nz-icon>
        Cole o JSON de Exemplo
      </h3>
      
      <p class="step-description">
        Forneça um JSON de exemplo que representa os dados que sua tela irá consumir.
        O algoritmo otimizado analisará a estrutura e sugerirá a melhor organização.
      </p>

      <!-- Quick Samples -->
      <div class="quick-samples">
        <span class="samples-label">📋 Exemplos rápidos:</span>
        <nz-button-group>
          <button nz-button nzSize="small" (click)="loadSampleJSON('simple')">
            <nz-icon nzType="file" nzTheme="outline"></nz-icon>
            Simples
          </button>
          <button nz-button nzSize="small" (click)="loadSampleJSON('shopee')">
            <nz-icon nzType="shopping" nzTheme="outline"></nz-icon>
            Shopee
          </button>
          <button nz-button nzSize="small" (click)="loadSampleJSON('exemplo')">
            <nz-icon nzType="appstore" nzTheme="outline"></nz-icon>
            Loja
          </button>
        </nz-button-group>
      </div>

      <!-- JSON Input -->
      <textarea
        nz-input
        [(ngModel)]="jsonInput"
        [nzAutosize]="{ minRows: 12, maxRows: 20 }"
        placeholder='{ "response": { "item_list": [ ... ] } }'
        class="json-textarea">
      </textarea>

      <!-- Error Message -->
      <nz-alert
        *ngIf="jsonError"
        nzType="error"
        [nzMessage]="jsonError"
        nzShowIcon
        class="error-alert">
      </nz-alert>

      <!-- Info Tips -->
      <nz-card nzSize="small" class="info-card">
        <nz-icon nzType="bulb" nzTheme="twotone" [nzTwotoneColor]="'#faad14'"></nz-icon>
        <span><strong>Dica:</strong> O JSON deve conter pelo menos um array de objetos para gerar uma tela completa.</span>
      </nz-card>
    </div>

    <!-- ===== STEP 1: Analysis ===== -->
    <div *ngIf="currentStep === 1" class="step-container step-analysis">
      <h3>
        <nz-icon nzType="radar-chart" nzTheme="twotone"></nz-icon>
        Análise Inteligente Concluída
      </h3>

      <div *ngIf="analysisResult">
        <!-- Summary Cards -->
        <div class="analysis-summary">
          <nz-card class="summary-card">
            <nz-statistic
              [nzValue]="analysisResult.entities.length"
              [nzTitle]="'Entidades Detectadas'"
              [nzPrefix]="summaryIconTemplate"
              [nzValueStyle]="{ color: '#1890ff' }">
            </nz-statistic>
            <ng-template #summaryIconTemplate>
              <nz-icon nzType="table" nzTheme="outline"></nz-icon>
            </ng-template>
          </nz-card>

          <nz-card class="summary-card">
            <nz-statistic
              [nzValue]="analysisResult.metadata.totalFields"
              [nzTitle]="'Campos Totais'"
              [nzValueStyle]="{ color: '#52c41a' }">
              <ng-template #summaryIconTemplate2>
                <nz-icon nzType="profile" nzTheme="outline"></nz-icon>
              </ng-template>
            </nz-statistic>
          </nz-card>

          <nz-card class="summary-card">
            <nz-statistic
              [nzValue]="analysisResult.metadata.maxDepth"
              [nzTitle]="'Profundidade Máxima'"
              [nzValueStyle]="{ color: '#722ed1' }">
            </nz-statistic>
          </nz-card>

          <nz-card class="summary-card strategy-card">
            <div class="strategy-content">
              <div class="strategy-title">Estratégia Sugerida</div>
              <nz-tag [nzColor]="'blue'" style="font-size: 14px; padding: 4px 12px;">
                {{ analysisResult.metadata.suggestedStrategy | uppercase }}
              </nz-tag>
            </div>
          </nz-card>
        </div>

        <!-- Warnings -->
        <nz-alert
          *ngIf="analysisResult.metadata.warnings.length > 0"
          nzType="warning"
          nzShowIcon
          [nzMessage]="'Avisos Importantes'"
          class="warnings-alert">
          <ul>
            <li *ngFor="let warning of analysisResult.metadata.warnings">{{ warning }}</li>
          </ul>
        </nz-alert>

        <!-- Entities List -->
        <div class="entities-section">
          <h4>
            <nz-icon nzType="unordered-list" nzTheme="outline"></nz-icon>
            Entidades Detectadas
          </h4>

          <nz-collapse [nzBordered]="true" class="entities-collapse">
            <nz-collapse-panel
              *ngFor="let entity of analysisResult.entities"
              [nzHeader]="entityHeaderTemplate"
              [nzActive]="isEntityExpanded(entity.name)">
              
              <ng-template #entityHeaderTemplate>
                <div class="entity-header">
                  <span class="entity-name">
                    <nz-icon 
                      [nzType]="getImportanceIcon(entity.importance)"
                      [nzTheme]="entity.importance === 'high' ? 'twotone' : 'outline'"
                      [nzTwotoneColor]="getImportanceColor(entity.importance)">
                    </nz-icon>
                    {{ entity.name }}
                  </span>
                  
                  <div class="entity-badges">
                    <nz-tag [nzColor]="'default'">
                      Nível {{ entity.level }}
                    </nz-tag>
                    <nz-tag [nzColor]="'blue'">
                      {{ entity.recordCount }} registro(s)
                    </nz-tag>
                    <nz-tag [nzColor]="getComplexityTag(entity.complexity).color">
                      Complexidade: {{ getComplexityTag(entity.complexity).text }}
                    </nz-tag>
                    <nz-tag 
                      *ngIf="entity.isPrimitiveArray"
                      [nzColor]="'purple'">
                      Array Primitivo
                    </nz-tag>
                  </div>
                </div>
              </ng-template>

              <!-- Entity Details -->
              <div class="entity-details">
                <div class="detail-row">
                  <strong>Path:</strong>
                  <code>{{ entity.dataPath }}</code>
                </div>
                <div class="detail-row" *ngIf="entity.parentEntity">
                  <strong>Entidade Pai:</strong>
                  <span>{{ entity.parentEntity }}</span>
                </div>
                <div class="detail-row">
                  <strong>Importância:</strong>
                  <nz-tag [nzColor]="getImportanceColor(entity.importance)">
                    {{ entity.importance | uppercase }}
                  </nz-tag>
                </div>
                <div class="detail-row">
                  <strong>Colunas:</strong>
                  <span>{{ entity.suggestedColumns.length }} coluna(s)</span>
                </div>
                <div class="detail-row">
                  <strong>Agrupamento Sugerido:</strong>
                  <span>{{ entity.suggestedGrouping || 'Auto' }}</span>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>

        <!-- Layout Preview -->
        <div class="layout-preview-section">
          <h4>
            <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
            Preview do Layout
          </h4>
          
          <div class="layout-stats">
            <div class="stat-item">
              <nz-icon nzType="folder" nzTheme="filled" [ngStyle]="{ color: '#1890ff' }"></nz-icon>
              <span class="stat-value">{{ estimatedTabsCount }}</span>
              <span class="stat-label">Tab(s)</span>
            </div>
            <div class="stat-item">
              <nz-icon nzType="appstore" nzTheme="filled" [ngStyle]="{ color: '#52c41a' }"></nz-icon>
              <span class="stat-value">{{ estimatedPanelsCount }}</span>
              <span class="stat-label">Painel(s)</span>
            </div>
            <div class="stat-item">
              <nz-icon nzType="table" nzTheme="filled" [ngStyle]="{ color: '#722ed1' }"></nz-icon>
              <span class="stat-value">{{ analysisResult.entities.length }}</span>
              <span class="stat-label">DataGrid(s)</span>
            </div>
          </div>

          <nz-card nzSize="small" class="strategy-description-card">
            <p>
              <nz-icon nzType="bulb" nzTheme="twotone" [nzTwotoneColor]="'#faad14'"></nz-icon>
              {{ getStrategyDescription(analysisResult.metadata.suggestedStrategy) }}
            </p>
          </nz-card>
        </div>
      </div>
    </div>

    <!-- ===== STEP 2: Configuration ===== -->
    <div *ngIf="currentStep === 2" class="step-container step-config">
      <h3>
        <nz-icon nzType="control" nzTheme="outline"></nz-icon>
        Configuração Avançada
      </h3>

      <div class="config-sections">
        
        <!-- Layout Strategy -->
        <nz-card nzTitle="Estratégia de Layout" [nzSize]="'small'" class="config-card">
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Estratégia</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-select [(ngModel)]="config.layoutStrategy" style="width: 100%;">
                <nz-option nzValue="auto" nzLabel="🤖 Automático (Recomendado)"></nz-option>
                <nz-option nzValue="single-tab" nzLabel="📄 Single Tab (Simples)"></nz-option>
                <nz-option nzValue="multi-tab" nzLabel="📁 Multi Tab (Organizado)"></nz-option>
                <nz-option nzValue="hierarchical" nzLabel="🏗️ Hierárquico (Complexo)"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-alert
            nzType="info"
            nzShowIcon
            [nzMessage]="getStrategyDescription(config.layoutStrategy)"
            style="margin-top: 12px;">
          </nz-alert>
        </nz-card>

        <!-- DataGrid Features -->
        <nz-card nzTitle="Funcionalidades do DataGrid" [nzSize]="'small'" class="config-card">
          <nz-row [nzGutter]="[16, 16]">
            <nz-col [nzSpan]="12">
              <label nz-checkbox [(ngModel)]="config.enablePagination">
                <nz-icon nzType="ordered-list" nzTheme="outline"></nz-icon>
                Paginação
              </label>
            </nz-col>
            <nz-col [nzSpan]="12">
              <label nz-checkbox [(ngModel)]="config.enableSorting">
                <nz-icon nzType="sort-ascending" nzTheme="outline"></nz-icon>
                Ordenação
              </label>
            </nz-col>
            <nz-col [nzSpan]="12">
              <label nz-checkbox [(ngModel)]="config.enableFilters">
                <nz-icon nzType="filter" nzTheme="outline"></nz-icon>
                Filtros
              </label>
            </nz-col>
            <nz-col [nzSpan]="12">
              <label nz-checkbox [(ngModel)]="config.enableCRUD">
                <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
                CRUD
              </label>
            </nz-col>
          </nz-row>

          <nz-form-item style="margin-top: 16px;" *ngIf="config.enablePagination">
            <nz-form-label [nzSpan]="8">Itens por Página</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-input-number
                [(ngModel)]="config.pageSize"
                [nzMin]="5"
                [nzMax]="100"
                [nzStep]="5"
                style="width: 100%;">
              </nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-card>

        <!-- Master-Detail & Forms -->
        <nz-card nzTitle="Master-Detail e Formulários" [nzSize]="'small'" class="config-card">
          <label nz-checkbox [(ngModel)]="config.enableMasterDetail">
            <nz-icon nzType="link" nzTheme="outline"></nz-icon>
            Habilitar Master-Detail
          </label>
          <nz-form-extra style="margin-left: 24px; margin-top: 4px;">
            Conecta grids a formulários de edição
          </nz-form-extra>

          <label nz-checkbox [(ngModel)]="config.autoGenerateForms" style="margin-top: 12px;">
            <nz-icon nzType="form" nzTheme="outline"></nz-icon>
            Gerar Formulários Automaticamente
          </label>
          <nz-form-extra style="margin-left: 24px; margin-top: 4px;">
            Cria campos de formulário para cada entidade
          </nz-form-extra>

          <nz-form-item style="margin-top: 16px;" *ngIf="config.autoGenerateForms">
            <nz-form-label [nzSpan]="8">Layout do Form</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-radio-group [(ngModel)]="config.formLayout">
                <label nz-radio nzValue="horizontal">Horizontal</label>
                <label nz-radio nzValue="vertical">Vertical</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </nz-card>

        <!-- Optimizations -->
        <nz-card nzTitle="⚡ Otimizações" [nzSize]="'small'" class="config-card">
          <label nz-checkbox [(ngModel)]="config.groupLowImportanceEntities">
            <nz-icon nzType="group" nzTheme="outline"></nz-icon>
            Agrupar Entidades de Baixa Importância
          </label>
          <nz-form-extra style="margin-left: 24px; margin-top: 4px;">
            Reduz número de tabs agrupando entidades menos relevantes
          </nz-form-extra>

          <label nz-checkbox [(ngModel)]="config.collapseComplexFields" style="margin-top: 12px;">
            <nz-icon nzType="fullscreen-exit" nzTheme="outline"></nz-icon>
            Colapsar Campos Complexos
          </label>
          <nz-form-extra style="margin-left: 24px; margin-top: 4px;">
            Inicia com painéis complexos colapsados para melhor UX
          </nz-form-extra>

          <label nz-checkbox [(ngModel)]="config.generateReadableLabels" style="margin-top: 12px;">
            <nz-icon nzType="font-colors" nzTheme="outline"></nz-icon>
            Gerar Labels Legíveis
          </label>
          <nz-form-extra style="margin-left: 24px; margin-top: 4px;">
            Converte nomes técnicos em labels mais amigáveis
          </nz-form-extra>

          <nz-form-item style="margin-top: 16px;">
            <nz-form-label [nzSpan]="8">Limite de Tabs</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-input-number
                [(ngModel)]="config.maxTabsLimit"
                [nzMin]="1"
                [nzMax]="20"
                style="width: 100%;">
              </nz-input-number>
              <nz-form-extra>
                Máximo de tabs para evitar poluição visual
              </nz-form-extra>
            </nz-form-control>
          </nz-form-item>
        </nz-card>
      </div>
    </div>

    <!-- ===== STEP 3: Generation ===== -->
    <div *ngIf="currentStep === 3" class="step-container step-generation">
      <div class="generation-ready">
        <nz-result
          nzStatus="success"
          nzTitle="Pronto para Gerar!"
          nzSubTitle="Clique em 'Gerar Tela' para criar sua tela otimizada com base nas configurações escolhidas.">
          <div nz-result-extra>
            <nz-card nzTitle="📊 Resumo da Geração" [nzSize]="'small'">
              <div class="generation-summary">
                <div class="summary-item">
                  <strong>Estratégia:</strong>
                  <span>{{ config.layoutStrategy | uppercase }}</span>
                </div>
                <div class="summary-item">
                  <strong>Tabs Estimadas:</strong>
                  <span>{{ estimatedTabsCount }}</span>
                </div>
                <div class="summary-item">
                  <strong>DataGrids:</strong>
                  <span>{{ analysisResult?.entities.length || 0 }}</span>
                </div>
                <div class="summary-item">
                  <strong>Master-Detail:</strong>
                  <span>{{ config.enableMasterDetail ? 'Habilitado' : 'Desabilitado' }}</span>
                </div>
                <div class="summary-item">
                  <strong>Formulários:</strong>
                  <span>{{ config.autoGenerateForms ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
            </nz-card>
          </div>
        </nz-result>
      </div>
    </div>

  </div>

  <!-- Modal Footer (dentro do conteúdo) -->
  <div class="wizard-footer" style="margin-top: 24px; text-align: right; border-top: 1px solid #f0f0f0; padding-top: 16px;">
    <button 
      nz-button 
      nzType="default" 
      (click)="close()">
      Cancelar
    </button>

    <button
      *ngIf="currentStep > 0"
      nz-button
      nzType="default"
      (click)="previous()"
      style="margin-left: 8px;">
      <nz-icon nzType="left" nzTheme="outline"></nz-icon>
      Voltar
    </button>

    <button
      *ngIf="currentStep < steps.length - 1"
      nz-button
      nzType="primary"
      (click)="next()"
      style="margin-left: 8px;">
      Próximo
      <nz-icon nzType="right" nzTheme="outline"></nz-icon>
    </button>

    <button
      *ngIf="currentStep === steps.length - 1"
      nz-button
      nzType="primary"
      (click)="generate()"
      style="margin-left: 8px;">
      <nz-icon nzType="thunderbolt" nzTheme="filled"></nz-icon>
      Gerar Tela Otimizada
    </button>
  </div>
  
  </ng-container>
</nz-modal>

